"use strict";
/**
 *
 * Remove duplicated items from an array
 *
 * @category Function
 * @param {string | Array} key - Object key to compare and remove it from the original array or an Array that will be removed duplicated items
 * @param {Array} arr - An array
 * @returns {Array} - New array without the duplicated items
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniq = void 0;
var uniq = function (key) {
    if (Array.isArray(key)) {
        return Array.from(new Set(key));
    }
    return function (arr) {
        return Array.from(arr.reduce(function (acc, item) { return item && item[key] && acc.set(item[key], item); }, new Map()).values());
    };
};
exports.uniq = uniq;
